module.exports = __webpack_public_path__ + "img/ondas.e3bd3fb7.svg";